<template>
  <div class="loader" v-bind:style="styleObject"></div>
</template>
<script>
  export default {
    name: "spinner",
    props: {
      size: {
        type: Number,
        default: function () {
          return 64
        }
      }
    },
    data() {
      return {
        styleObject: {
          width: this.size + 'px',
          height: this.size + 'px',
          'border-width': (this.size / 8) + 'px'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../style/global.scss';

  .loader {
    border-style: solid;
    border-color: $light-grey;
    border-top-color: $blue;
    border-bottom-color: $blue;
    border-radius: 50%;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spinner.vue